import React from 'react';
import Modal from 'react-modal';
import cn from 'classnames/bind';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';

import ButtonClose from '../../../../components/ButtonClose/ButtonClose';
import UserFieldSet from '../UserFieldSet/UserFieldSet';

import styles from '../CreateUserModal/CreateUserModal.module.css';
import fieldStyles from '../UserFieldSet/UserFieldSet.module.css';
import api from '../../../../utils/api';
import { notify } from '../../../../components/Toast/Toast';
import * as errorMessages from '../../../../utils/error-messages';

const cx = cn.bind(styles);
const schema = Yup.object().shape({
  password: Yup.string().required(errorMessages.blank),
});

// Администратор задаёт пользователю новый пароль и сам передаёт его пользователю:
// письма на проде не отправляются
function ResetPasswordModal(props) {
  const { user } = props;

  function handleSubmit({ password }, actions) {
    api
      .post(`/users/${user.id}/set-password/`, { newPassword: password })
      .then(() => {
        notify(`Пароль для ${user.email} изменён. Передайте его пользователю`);
        props.onClose();
      })
      .catch(({ response }) => {
        const detail = response?.data?.newPassword?.[0];
        actions.setFieldError('password', detail?.detail || detail || 'Не удалось изменить пароль');
        actions.setFieldTouched('password', true, false);
      })
      .finally(() => actions.setSubmitting(false));
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onClose}
      shouldCloseOnOverlayClick
      closeTimeoutMS={300}
      className={cx({ modal: true })}
      overlayClassName={cx({ overlay: true })}
    >
      {user && (
        <Formik
          initialValues={{ password: '' }}
          validationSchema={schema}
          onSubmit={handleSubmit}
          render={({ touched, errors, isSubmitting, ...actions }) => (
            <Form>
              <section className={styles.wrapper}>
                <div className={styles.header}>
                  <p className={styles.title}>Сброс пароля</p>

                  <ButtonClose
                    onClick={props.onClose}
                    stroke="var(--dark-gray)"
                    className={cx({ 'btn-close': true })}
                  />
                </div>

                <div className={cx({ content: true })}>
                  <div className={fieldStyles['title-wrapper']}>
                    <p className={fieldStyles['field-title']}>Пользователь</p>
                  </div>
                  <p className={styles.user}>
                    {user.fullName}
                    <br />
                    {user.email}
                  </p>

                  <UserFieldSet
                    title="Новый пароль"
                    type="password"
                    name="password"
                    touched={touched}
                    errors={errors}
                    actions={actions}
                  />

                  <div className={cx({ buttons: true })}>
                    <button type="submit" disabled={isSubmitting} className={cx({ 'btn-create': true })}>
                      Сохранить
                    </button>

                    <button type="button" onClick={props.onClose} className={cx({ 'btn-cancel': true })}>
                      Отменить
                    </button>
                  </div>
                </div>
              </section>
            </Form>
          )}
        />
      )}
    </Modal>
  );
}

export default ResetPasswordModal;
